/* ------------------------------------------------------------------ */
/*  home-hero-premium.js                                               */
/*  Progressive enhancement only — no behavior depends on it.          */
/* ------------------------------------------------------------------ */

(function () {
  /* Gate scroll-reveal CSS (html.mm-js .mm-reveal …) on JS being alive. */
  document.documentElement.classList.add('mm-js');
})();

document.addEventListener('DOMContentLoaded', function () {
  var hero = document.getElementById('hhp-hero');

  if (!hero) {
    return;
  }

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var animEnabled = hero.getAttribute('data-anim') === 'true' && !reduceMotion;

  /* 1) Premium header: transparent at top -> white after scrolling.
       Scoped to this stylesheet only being loaded when the hero is
       present, so the class only ever exists on pages with the hero. */
  var header = document.getElementById('shopify-section-header');

  if (header) {
    var ticking = false;

    function updateHeader() {
      document.body.classList.toggle('mm-header-scrolled', window.scrollY > 24);
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    updateHeader();
  }

  /* 2) Reveal-on-scroll for the sections below the fold. */
  var revealTargets = hero.querySelectorAll('.mm-reveal');

  if ('IntersectionObserver' in window && animEnabled) {
    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in-view');
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }
    );

    revealTargets.forEach(function (el) {
      observer.observe(el);
    });
  } else {
    revealTargets.forEach(function (el) {
      el.classList.add('is-in-view');
    });
  }

  /* 3) Slideshow: navigation, dots, autoplay and swipe. */
  var slideshow = hero.querySelector('.mm-slideshow');

  if (slideshow) {
    var slides = hero.querySelectorAll('.mm-slide');
    var track = slideshow.querySelector('.mm-slides');
    var dots = slideshow.querySelectorAll('.mm-slideshow__dot');
    var count = slides.length;
    var index = 0;
    var timer = null;
    var autoplay =
      slideshow.getAttribute('data-autoplay') === 'true' && count > 1 && !reduceMotion;
    var speed = parseInt(slideshow.getAttribute('data-speed') || '5', 10) * 1000;

    function goTo(i) {
      index = (i + count) % count;
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      dots.forEach(function (dot, n) {
        dot.classList.toggle('is-active', n === index);
        dot.setAttribute('aria-selected', n === index ? 'true' : 'false');
      });
      restart();
    }

    function next() {
      goTo(index + 1);
    }

    function prev() {
      goTo(index - 1);
    }

    function restart() {
      if (!autoplay) {
        return;
      }
      stop();
      timer = window.setInterval(next, speed);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    dots.forEach(function (dot, n) {
      dot.addEventListener('click', function () {
        goTo(n);
      });
    });

    if (autoplay) {
      slideshow.addEventListener('mouseenter', stop);
      slideshow.addEventListener('mouseleave', restart);
      slideshow.addEventListener('focusin', stop);
      slideshow.addEventListener('focusout', restart);
      restart();
    }

    var startX = null;

    slideshow.addEventListener(
      'touchstart',
      function (event) {
        startX = event.touches[0].clientX;
      },
      { passive: true }
    );

    slideshow.addEventListener(
      'touchend',
      function (event) {
        if (startX === null) {
          return;
        }
        var dx = event.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) {
          if (dx < 0) {
            next();
          } else {
            prev();
          }
        }
        startX = null;
      },
      { passive: true }
    );

    goTo(0);
  }

  /* 4) Button ripple. */
  hero.querySelectorAll('.mm-btn, .mm-bottomcta__btn').forEach(function (btn) {
    btn.addEventListener('click', function (event) {
      if (reduceMotion) {
        return;
      }

      var rect = this.getBoundingClientRect();
      var size = Math.max(rect.width, rect.height);
      var ripple = document.createElement('span');

      ripple.className = 'mm-ripple';
      ripple.style.width = size + 'px';
      ripple.style.height = size + 'px';
      ripple.style.left = event.clientX - rect.left - size / 2 + 'px';
      ripple.style.top = event.clientY - rect.top - size / 2 + 'px';

      this.appendChild(ripple);

      ripple.addEventListener('animationend', function () {
        ripple.remove();
      });
    });
  });
});
